<template>
  <button :type="type" :disabled="disabled" :class="classes" v-bind="$attrs">
    <slot />
  </button>
</template>

<script>
const VARIANTS = {
  default: "bg-primary text-primary-foreground hover:opacity-90",
  brand: "bg-brand-green text-brand-dark font-semibold hover:bg-brand-green-hover",
  secondary: "bg-secondary text-secondary-foreground hover:opacity-80",
  outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
  ghost: "hover:bg-accent hover:text-accent-foreground",
  destructive: "bg-destructive text-white hover:opacity-90",
};

const SIZES = {
  default: "h-9 px-4 py-2",
  sm: "h-8 rounded-md px-3 text-xs",
  lg: "h-10 rounded-md px-8",
  icon: "h-9 w-9",
};

export default {
  name: "UiButton",
  inheritAttrs: false,
  props: {
    variant: { type: String, default: "default" },
    size: { type: String, default: "default" },
    type: { type: String, default: "button" },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return [
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        "disabled:pointer-events-none disabled:opacity-50",
        VARIANTS[this.variant] || VARIANTS.default,
        SIZES[this.size] || SIZES.default,
      ];
    },
  },
};
</script>
